import { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { appRoutes } from "@/routes/appRoutes";
import { getAdsBasePath } from "@/utils/basePath";

/**
 * Panel multicliente. Router de datos (no `BrowserRouter`) porque la guardia de formularios sin guardar
 * necesita `useBlocker`.
 */
export function App() {
  const [router] = useState(() => createBrowserRouter(appRoutes, { basename: getAdsBasePath() || undefined }));
  useEffect(() => () => router.dispose(), [router]);
  return <RouterProvider router={router} />;
}
